import { useCallback } from 'react';
import { withUpdatedColumnWidths } from './column-resize';

export default function useColumnWidthsChange(setColumns, setAllColumns) {
  return useCallback(
    (columns) => {
      setColumns(columns);
      setAllColumns((previous) => withUpdatedColumnWidths(previous, columns));
    },
    [setColumns, setAllColumns]
  );
}
